import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import localeFr from '@angular/common/locales/fr';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { AccessibilityStatementComponent } from './components/accessibility-statement/accessibility-statement.component';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthService, WINDOW } from './services/auth/auth.service';
import { ConnexionComponent } from './components/connexion/connexion.component';
import { CookiesComponent } from './components/cookies/cookies.component';
import { DeconnexionComponent } from './components/deconnexion/deconnexion.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { httpInterceptorProviders } from './shared/interceptors';
import { httpTranslateLoader } from './shared/translation/http-translate-loader';
import { PageInMaintenanceComponent } from './components/page-in-maintenance/page-in-maintenance.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { SharedModule } from './shared/shared.module';
import { UserInfoService } from './services/user-info/user-info.service';

registerLocaleData(localeFr, 'fr-FR');

@NgModule({
  imports: [
    AccordionModule.forRoot(),
    AlertModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    BsDatepickerModule.forRoot(),
    FormsModule,
    HttpClientModule,
    NgIdleKeepaliveModule.forRoot(),
    SharedModule,
    TooltipModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
    TypeaheadModule.forRoot(),
  ],
  declarations: [
    AccessibilityStatementComponent,
    AppComponent,
    ConnexionComponent,
    CookiesComponent,
    DeconnexionComponent,
    FooterComponent,
    HeaderComponent,
    HomeComponent,
    PageInMaintenanceComponent,
    PageNotFoundComponent,
  ],
  providers: [
    httpInterceptorProviders,
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: WINDOW, useValue: window },
    AuthService,
    UserInfoService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
